import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';
import { RewardPointGenerateTokenResponse, RewardPointGenerateTokenResponseDtoImpl } from '../api/rewardpoint/rewardpointgeneratetoken/rewardpointgeneratetokenresponse';
import { FlashMessageGenerateTokenBuilder } from '../dto/flashmessagegenereratetoken/flashmessagegeneratetokenbuilder';
import { RewardPointGenerateTokenRequest } from '../api/rewardpoint/rewardpointgeneratetoken/rewardpointgeneratetokenrequest';

export class RewardPointGenerateTokenAPIProcessorImpl extends SixdeeCRBTAPIProcessor<RewardPointGenerateTokenRequest, RewardPointGenerateTokenResponse>
{
    private LOGGER: Logger = LogManager.getLogger(RewardPointGenerateTokenAPIProcessorImpl.name);
    execute(request: RewardPointGenerateTokenRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void {
        this.LOGGER.log("onSuccess() invoked");
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {
                let responseData = responseMapper.getResponseMap();
                let response = new RewardPointGenerateTokenResponseDtoImpl(APIFeatures.REWARD_POINT_GENERATE_TOKEN, "Get Reward Point Generate Token Success");

                response.setRewardPointGenerateTokenResponseDto(new FlashMessageGenerateTokenBuilder(responseData).buildAll());

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new RewardPointGenerateTokenResponseDtoImpl(APIFeatures.REWARD_POINT_GENERATE_TOKEN, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new RewardPointGenerateTokenResponseDtoImpl(APIFeatures.REWARD_POINT_GENERATE_TOKEN, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new RewardPointGenerateTokenResponseDtoImpl(APIFeatures.REWARD_POINT_GENERATE_TOKEN, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        let message = "FAILED";
        if(responseMapper && responseMapper.getStatusMsg() !== null && responseMapper.getStatusMsg() !== undefined)
        {
            message = responseMapper.getStatusMsg();
        }
        this.getAPIFailure(new RewardPointGenerateTokenResponseDtoImpl(APIFeatures.REWARD_POINT_GENERATE_TOKEN, message));   
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/rewardpointgeneartetokenapiprocessor.tsx